import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";
import { useExpenseStore } from "../store";

export const rejectRequisition = ({
  churchId,
  requisitionData,
  requisitionId
}) => {
  return axios.patch(
    `/churches/${churchId}/requisitions/${requisitionId}/reject`,
    requisitionData
  );
};

export const useRejectRequisition = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const closeRequisitionFlowModal =
    useExpenseStore.getState().closeRequisitionFlowModal;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(["requisitions"]);
      queryClient.invalidateQueries(["requisitions-paginated"]);
      queryClient.invalidateQueries(["requisition"]);

      setNotification({
        type: "success",
        message: "Requisition rejected successfully!"
      });
      closeRequisitionFlowModal();
    },
    ...config,
    mutationFn: rejectRequisition
  });
};
